import * as React from 'react';
import Spinner from '@atlaskit/spinner';
import * as grid from 'view/styles/grid';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { noop } from 'lodash';
import { AbsoluteFillContainer, Container, LoadingSkeletonFields, Message } from './styled';
import { SPINNER_DELAY } from '@atlassian/help-center-common-component/constants';
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

export type LoadingPosition = 'static' | 'fill-container';

interface Props {
    loadingPosition?: LoadingPosition;
    isLoading?: boolean;
    pastDelay?: boolean;
    timedOut?: boolean;
    error?: React.ReactNode;
    onComplete?: () => void;
    isCompleting?: boolean;
}

const ICON_SIZE = grid.multiple(6);

export const ChunkLoadErrorMessage: React.FC = () => {
    return (
        <>
            <ErrorIcon label="" size="xlarge" />
            <Message>
                <FormattedMessage {...messages.error} />
            </Message>
        </>
    );
};

export const MarginTop = styled.div`
    margin-top: ${token('space.025', '2px')};
`;

export const SkeletonLoadingWrapper = (props: Props) => {
    let content;

    if (props.error) {
        content = <ChunkLoadErrorMessage />;
    } else {
        content = (
            <>
                <LoadingSkeletonFields />

                {props.timedOut && (
                    <Message>
                        <FormattedMessage {...messages.timeout} />
                    </Message>
                )}
            </>
        );
    }

    const Wrapper = props.loadingPosition === 'static' ? AbsoluteFillContainer : Container;

    return (
        <MarginTop>
            <Wrapper>{content}</Wrapper>
        </MarginTop>
    );
};

const Loading = (props: Props) => {
    let content;

    if (props.error) {
        content = <ChunkLoadErrorMessage />;
    } else {
        content = (
            <>
                <Spinner
                    delay={SPINNER_DELAY}
                    invertColor={false}
                    isCompleting={props.isCompleting || false}
                    onComplete={props.onComplete || noop}
                    size={ICON_SIZE.unitless}
                />

                {props.timedOut && (
                    <Message>
                        <FormattedMessage {...messages.timeout} />
                    </Message>
                )}
            </>
        );
    }

    const Wrapper = props.loadingPosition === 'static' ? AbsoluteFillContainer : Container;

    return <Wrapper>{content}</Wrapper>;
};

export default Loading;
